import dayjs from 'dayjs';
import { getDayjsFromSecomDate, getUnixFromSecomDate } from './date';
import { EVENT_BOUNDARY_OFFSET_MS } from '@/globals/constants';

/**
 * Map event list
 * @param {*} list
 * @returns
 */
export const mapEventList = (list, currentLength = 0) => {
  if (list && list.length > 0) {
    return list.map((event, index) => {
      const startEventUnix = getDayjsFromSecomDate(
        event.eventStartDate
      ).valueOf();
      const endEventUnix = getDayjsFromSecomDate(event.eventEndDate).valueOf();
      const diff = dayjs(endEventUnix).diff(dayjs(startEventUnix));
      let format = 'mm:ss';
      if (dayjs.duration(diff).asHours().toFixed() > 0) {
        format = 'HH:mm:ss';
      }
      const duration = dayjs.duration(diff).format(format);
      const suspect =
        event.eventMetaDatas.findIndex(
          (event) => event.value === '不審物の検知'
        ) !== -1;

      return {
        ...event,
        startEventUnix,
        endEventUnix,
        duration,
        suspect,
        diff,
        eventIndex: currentLength + index,
      };
    });
  }
  return [];
};

/**
 * Map event list for seek-bar
 * @param {Array} list of events
 * @returns
 */
export const mapEventListSeekbar = (list) => {
  return list?.length
    ? list
        .filter((e) => e && e.eventStartDate && e.eventEndDate)
        .map((event) => {
          const parsedEvent = {};
          const startEventUnix = getDayjsFromSecomDate(
            event.eventStartDate
          ).valueOf();
          const endEventUnix = getDayjsFromSecomDate(
            event.eventEndDate
          ).valueOf();
          parsedEvent.startUnix = startEventUnix;
          parsedEvent.start = dayjs(startEventUnix).format(
            'YYYY-MM-DDTHH:mm:ss'
          );
          parsedEvent.endUnix = endEventUnix;
          parsedEvent.end = dayjs(endEventUnix).format('YYYY-MM-DDTHH:mm:ss');
          parsedEvent.eventId = event.eventId;
          parsedEvent.cameraId = event.cameraId;
          parsedEvent.title = event.eventMetaDatas[0]?.value;
          return parsedEvent;
        })
    : [];
};

/**
 * Parse timeline events
 * @param {*} list
 * @returns
 */
export const parseTimelineEvents = (list) => {
  const parsedEventList = [];
  if (!list) {
    return parsedEventList;
  }
  list.forEach((event) => {
    if (event && event.eventStartDate && event.eventEndDate) {
      const parsedEvent = {};
      const startEventUnix = getUnixFromSecomDate(event.eventStartDate);
      const endEventUnix = getUnixFromSecomDate(event.eventEndDate);
      parsedEvent.start = dayjs
        .unix(startEventUnix)
        .format('YYYY-MM-DDTHH:mm:ss');
      parsedEvent.end = dayjs.unix(endEventUnix).format('YYYY-MM-DDTHH:mm:ss');
      parsedEvent.eventId = event.eventId;
      parsedEvent.cameraId = event.cameraId;
      parsedEvent.title = event.eventMetaDatas[0].value;
      parsedEventList.push(parsedEvent);
    }
  });
  return parsedEventList;
};

/**
 * Get event start timestamp with boundary offset
 * Adds a small offset to the event start time to ensure event detection
 * happens after the boundary condition, preventing edge case timing issues
 *
 * @param {number} eventStartUnix - Event start timestamp in Unix milliseconds
 * @returns {number} Adjusted timestamp with boundary offset
 */
export const getEventStartWithOffset = (eventStartUnix) => {
  return eventStartUnix + EVENT_BOUNDARY_OFFSET_MS;
};
